import React from 'react';
import { NavLink } from 'react-router-dom';
import 'chartjs-plugin-datalabels';
import _ from 'lodash';
import { Button } from 'carbon-components-react';
import { Bar } from 'react-chartjs-2';
import { Card } from '../../../components';

const CardChartAgency = ({ chartOptions, data, dataChart, text, title, subtitle, hideFilter, date, dates, openMd, titleBtnList, titleBtnList2, openList, openList2, height, className }) => (

  <Card className={`dashboard-card dashboard-card--agency ${className}`}>
    <div className="bx--row">
      <div className="bx--col-md-9 bx--col-xs-12 bx--col-sm-9">
        <h2>
          {title}
          {subtitle && (
            <span>
              <br />
              {subtitle}
            </span>
          )}
          <br />
          {dates && (
            <span>
              {`Período:  ${dates.dateInit} à ${dates.dateFinish}`}
            </span>
          )}
          {date && (
            <span>
              {`Trimestre:  ${date}`}
            </span>
          )}
        </h2>
      </div>
      {!hideFilter && (
        <div className="bx--col-md-3 bx--col-xs-12 bx--col-sm-3">
          <Button
            kind="ghost"
            className="link-filter bx--btn btn-ghost"
            onClick={() => openMd()}
          >
            Filtrar
          </Button>
        </div>
      )}

    </div>
    <div className="chart" style={{ width: "95%" }}>
      {text && (
        <p style={{ padding: "0 0 15px 30px" }}>
          <strong>
            {text}
          </strong>
        </p>
      )}
      <Bar
        data={dataChart}
        height={height || 60}
        maintainAspectRatio="true"
        options={{
          legend: {
            display: true,
            position: "bottom",
            "fullWidth": true,
            maintainAspectRatio: true,
            onClick: (e) => e.stopPropagation()
          },
          plugins: {
            datalabels: {
              display: true,
              color: 'black'
            }
          },
          ...chartOptions
        }}
      />
    </div>
    {data.map(obj => {
      const classNames = [
        'dashboard-card-item',
        obj.extra ? 'dashboard-card-item--extra' : '',
        obj.featured ? 'dashboard-card-item--bold' : ''
      ].join(' ');
      return (
        <NavLink to={obj.url || "#"} key={_.uniqueId()} className={classNames}>
          <div className="description">{obj.label}</div>
          <div className="count">{obj.total}</div>
        </NavLink>
      );
    })}
    <div className="dashboard-card dashboard-card--agency">
      <br />
      <Button
        className="link-list bx--btn btn-ghost"
        kind="ghost"
        onClick={() => openList()}
      >
        {titleBtnList}
      </Button>
      {titleBtnList2 && (
        <Button
          className="link-list bx--btn btn-ghost"
          kind="ghost"
          onClick={() => openList2()}
        >
          {titleBtnList2}
        </Button>
      )}
    </div>

  </Card>
);

export default CardChartAgency;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/card-chart-agency.js